module.exports = {
  baseUrl: "https://api.singhcoin.io",
  // baseUrl: "https://staging-api.singhcoin.io",
};
